var _rect, _rect2, _rect3, _rect4, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptimise = function SvgOptimise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 6,
    y: 53,
    fill: "#B4CFFF",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 16,
    x: 22,
    y: 47,
    fill: "#2F68D1",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 26,
    x: 39,
    y: 37,
    fill: "#6C9BF1",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 51,
    x: 55,
    y: 12,
    fill: "#2F68D1",
    rx: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "#FF9D43",
    stroke: "#FF9D43",
    transform: "matrix(-1 0 0 1 37 29)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m33 33 5-10M45.5 20.5l3.764-3.763A23 23 0 0 0 14.94 47.244L20 44M33 16v-6M20.98 20.98l-4.243-4.243M16 33h-6"
  })));
};
export default SvgOptimise;